export const CREATE_WITH_AGENT_COPY = {
  menu: "Create with an Agent",
  title: "New task with an agent",
  endSession: "End session",
  endSessionAsk: "End this session?",
  endSessionBody: "The machine will stop. Tasks you already created stay in the backlog.",
  endSessionConfirm: "End session",
  keepSession: "Keep session",
  send: "Send",
  you: "You",
  youSurvey: "You (survey response)",
  sendAnswers: "Send answers",
  skipSurvey: "Skip",
  previousQuestion: "Previous",
  nextQuestion: "Next",
  otherAnswer: "Or write your own answer",
  surveySkipped: "Skipped the survey.",
  composerPlaceholder: "Tell the agent what you want to do",
  viewingOlder: "You are viewing older messages.",
  jumpToLatest: "Jump to latest",
  machineStarting: "The machine is starting",
  machineRunning: "Machine is running",
  machineWaiting: "Waiting for you",
  machineStopped: "The machine stopped",
  machineFailedBody: "The run failed. End this session and start again.",
  emptyHeadline: "Waiting for your first task.",
  emptyBody: "The agent will draft a task here.",
  draftLabel: "Draft task",
  sessionList: "This session",
  create: "Create",
  skip: "Skip",
  refineFurther: "Refine further",
  openTask: "Open task",
  greeting: "The repository is ready. What do you want to do?",
  afterCreate: "The task is created. Tell me if you want to do something else.",
  afterSkip: "Skipped that draft. Tell me if you want to do something else.",
  failedStart: "Failed to start the session.",
  failedSend: "Failed to send the message.",
  failedSurvey: "Failed to send the answers.",
  failedDraft: "Failed to save the draft.",
  failedCreate: "Failed to create the task.",
  failedSkip: "Failed to skip the draft.",
} as const;

export function planningRefineNote(key: string, title: string) {
  return `Refine ${key}: ${title}.`;
}
